export const isNeedCorrectPhone = (message: string) => {
  return message.toLowerCase().includes('invalid phone number')
}
